import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // URLs que não precisam de autenticação
  const publicUrls = [
    '/api/auth/login',
    '/api/auth/register',
    '/api/auth/refresh',
    '/api/public'
  ];

  // Verifica se é uma URL pública
  const isPublicUrl = publicUrls.some(url => req.url.includes(url));
  const isLogoutUrl = req.url.includes('/Session/Logout');

  if (!isPublicUrl && authService.isAuthenticatedSync()) {
    const token = authService.getToken();
    
    if (token) {
      // Clona a requisição e adiciona o header de autorização
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      return next(authReq).pipe(
        catchError(error => {
          // Se retornar 401 (Unauthorized), redireciona para login com returnUrl
          if (error.status === 401 && !isLogoutUrl) {
            authService.logout({ navigate: false });
            router.navigate(['/auth/login'], {
              queryParams: { returnUrl: window.location.pathname + window.location.search }
            });
          }
          return throwError(() => error);
        })
      );
    }
  }

  return next(req).pipe(
    catchError(error => {
      // Tratamento de erros para requisições não autenticadas
      if (error.status === 401 && !isPublicUrl && !isLogoutUrl) {
        authService.logout({ navigate: false });
        router.navigate(['/auth/login'], {
          queryParams: { returnUrl: window.location.pathname + window.location.search }
        });
      }
      return throwError(() => error);
    })
  );
};
